<prcins-card headerClass="bg-es-blue text-white" *ngIf="premiumDetails$ | async as premiumDetails; else loading">
  <span header-left>Policy Premium</span>
  <div body class="mx-4 my-2">
    <ng-container>
      <div class="px-8 py-4 border rounded bg-es-sky-blue">
        <div class="flex justify-between flex-wrap-reverse flex-col-reverse sm:flex-row">

          <div class="flex flex-col items-center sm:items-start">
            <span class="font-bold">Policy Period</span>
            <span class="sm:mt-4 text-sm">{{premiumDetails.startDate | date : 'MM/dd/yyyy'}} to
              {{premiumDetails.endDate | date : 'MM/dd/yyyy'}}</span>
          </div>
          <div class="flex flex-col items-center sm:items-end">
            <span class="font-bold">Total Premium & Fees</span>
            <span class="text-es-orange text-3xl mb-4 sm:mb-0">{{premiumDetails.totalPremium | currency : 'USD'}}</span>
          </div>
        </div>
      </div>

      <div *ngFor="let premiumEntry of premiumDetails.premiumEntries; last as isLast"
        [ngSwitch]="premiumEntry.premiumType">
        <span class="flex justify-between mt-3 pb-2 font-bold border border-t-0 border-r-0 border-l-0"
          [class.border-b-0]="isLast">
          <span *ngSwitchCase="'HOME'">{{premiumEntry.premiumName}}</span>
          <span *ngSwitchCase="'VEHICLE'">{{premiumEntry.premiumName}}</span>
          <span *ngSwitchCase="'PLIGA'">
            <prcins-tooltip>
              <ng-container tooltip-label>PLIGA</ng-container>
              <ng-container tooltip-text>
                <p class="w-64 font-normal">
                  PLIGA stands for Property-Liability Insurance Guaranty Association. New Jersey Property and Casualty
                  insurance companies are required to be members of NJ PLIGA and collect funds from their customers for
                  NJ
                  PLIGA's operations. The PLIGA fee on your policy supplies a pool of money to pay claims in the event
                  an
                  insurance company becomes insolvent.
                </p>
              </ng-container>
            </prcins-tooltip>
          </span>
          <span *ngSwitchCase="'MVLEF'">
            <prcins-tooltip>
              <ng-container tooltip-label>MVLEF</ng-container>
              <ng-container tooltip-text>
                <p class="w-64 font-normal">
                  MVLEF stands for Motor Vehicle Law Enforcement Fee. New York requires insurance companies to assess a
                  fee for each insured vehicle. These fees are used to offset costs combating insurance related fraud
                  and
                  crimes.
                </p>
              </ng-container>
            </prcins-tooltip>
          </span>
          <span *ngSwitchCase="'CTHHF'">
            <prcins-tooltip>
              <ng-container tooltip-label>CT Healthy House Fund</ng-container>
              <ng-container tooltip-text>
                <p class="w-64 font-normal">
                  Effective January 1, 2019, insurance companies in Connecticut are required to collect a surcharge on
                  each homeowner policy, including condominium insurance policies. Money collected through this
                  surcharge
                  is submitted to the "Healthy House Fund" as established by House Bill no. 5209. The surcharge is not
                  part of the premium paid for insuring your home.
                </p>
              </ng-container>
            </prcins-tooltip>
          </span>
          <span *ngSwitchCase="'OTHERS'">
            <prcins-tooltip>
              <ng-container tooltip-label>Other Coverage and Fees</ng-container>
              <ng-container tooltip-text>
                <p class="w-64 font-normal">
                  This amount represents any purchased coverages that are not included in the price per-vehicle you see
                  on
                  this page. This may include any of the following if purchased by you: Assurance Preferred Package,
                  Assurance Premier Package, Accident Forgiveness Coverage, as well as our sports and other special
                  programs.
                </p>
              </ng-container>
            </prcins-tooltip>
          </span>
          <span>{{premiumEntry.premiumAmt  | currency : 'USD'}}</span>
        </span>
      </div>
    </ng-container>
  </div>
</prcins-card>

<ng-template #loading>
  <prcins-card pt="pt-0">
    <div body>
      <prcins-skeleton numOfRows="5"></prcins-skeleton>
    </div>
  </prcins-card>
</ng-template>